import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

// Register Stimulus controllers found in `engines/site_corpo/app/components`
const stimulusControllers = import.meta.glob('./controllers/**/*_controller.js', { eager: true });
const stimulusComponentControllers = import.meta.glob('../components/**/*_controller.js', { eager: true });

window.Stimulus = Application.start();

registerControllers(window.Stimulus, stimulusComponentControllers);
registerControllers(window.Stimulus, stimulusControllers);
